import { SidebarTrigger } from '#app/components/ui/sidebar'

export function MobileHeader() {
	return (
		<header className="bg-background text-foreground w-screen-minus-112 sticky top-0 flex flex-col justify-start pt-5 pb-6 pl-28 hover:z-10">
			<h2 className="text-3xl leading-none font-semibold tracking-tight text-nowrap">
				Clearwater Farms
			</h2>
			<h3 className="text-xl leading-none tracking-tight text-nowrap">
				Unit 1
			</h3>
			<div className="fixed top-4 left-4 z-50">
				<SidebarTrigger />
			</div>
		</header>
	)
}
